import { useEnabledActions, useStatuses } from '../context';
import { Statuses } from './StatusesMap';
export const useSuggestionStatuses = () => {
  const overridesStatuses = useStatuses();
  const statuses = {
    ...Statuses,
    ...overridesStatuses
  };
  return statuses;
};
export const useDomainSearchStatuses = () => {
  const overridesStatuses = useStatuses();
  const enabledActions = useEnabledActions();
  // merge default statuses with overrides
  const statuses = {
    ...Statuses,
    ...overridesStatuses
  };
  const filteredStatuses = enabledActions != null && enabledActions.length ? Object.fromEntries(Object.entries(statuses).filter(_ref => {
    let [key] = _ref;
    return enabledActions.includes(key);
  })) : statuses;
  return filteredStatuses;
};
//# sourceMappingURL=useStatuses.js.map